import * as types from "../Action/type"
const initialState = {
    path: [],
}
const SubHeader = (state = initialState, action) => {
  switch (action.type) {
    case types.SUBHEADER:
      return { ...state, path:action.payload }
    default:
      return state;
  }
}
export default SubHeader;
